var map = {
	"./barstool/theme.js": 85076,
	"./foldsOfHonor/theme.js": 94135,
	"./golfBook/theme.js": 67033,
	"./golfDigest/theme.js": 53248,
	"./randomGolf/theme.js": 52875,
	"./supremeGolf/theme.js": 34865,
	"./theWeatherChannel/theme.js": 49562
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88330;